import * as types from './insightActionType';

export const insightReservationPickupRequest = (
  payload: InsightReservationPickupRequest['payload']
): types.InsightReservationPickupRequest => ({
  type: types.INSIGHT_RESERVATION_PICKUP_REQUEST,
  payload,
});

type InsightReservationPickupRequest = types.InsightReservationPickupRequest;

export const insightBookingPaceRequest = (
  payload: types.InsightBookingPaceRequest['payload']
): types.InsightBookingPaceRequest => ({
  type: types.INSIGHT_BOOKING_PACE_REQUEST,
  payload,
});

export const insightProductivityRequest = (
  payload: types.InsightProductivityRequest['payload']
): types.InsightProductivityRequest => ({
  type: types.INSIGHT_PRODUCTIVITY_REQUEST,
  payload,
});

export const insightProcessSuccess = (
  payload: types.InsightProcessSuccess['payload']
): types.InsightProcessSuccess => ({
  type: types.INSIGHT_PROCESS_SUCCESS,
  payload,
});

export const insightProcessReset = (): types.InsightProcessReset => ({
  type: types.INSIGHT_PROCESS_RESET,
});
